import { call } from 'redux-saga/effects'

import actions from 'actions'
import api from 'services'

import { fetchEntity } from 'utils/sagas'


const { partnerPromoCodes, createPromoCode, updatePromoCode } = actions

const fetchPromoCodesPartnerCodes = fetchEntity.bind(null, partnerPromoCodes, api.fetchPromoCodesPartnerCodes)

export function* promoCodeLoadPartnerCodes({ partnerId }) {
  yield call(fetchPromoCodesPartnerCodes, partnerId)
}

const fetchCreatePromoCode = fetchEntity.bind(null, createPromoCode, api.createPromoCode)

export function* promoCodeCreate({ partnerId, values }) {
  yield call(fetchCreatePromoCode, partnerId, values)
}

const fetchUpdatePromoCode = fetchEntity.bind(null, updatePromoCode, api.updatePromoCode)

export function* promoCodeEdit({ promoCodeId, values }) {
  yield call(fetchUpdatePromoCode, promoCodeId, values)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/promo-code/promo-code-sagas.js
 **/